var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6271 9.08247L10.1141 16.5955C8.40556 18.304 5.63546 18.304 3.92692 16.5955C2.21837 14.8869 2.21837 12.1168 3.92692 10.4083L11.4399 2.89529C12.579 1.75626 14.4257 1.75626 15.5647 2.89529C16.7037 4.03432 16.7037 5.88105 15.5647 7.02008L8.34633 14.2385C7.77682 14.808 6.85345 14.808 6.28394 14.2385C5.71442 13.6689 5.71442 12.7456 6.28394 12.1761L12.6184 5.84157",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachment);
export default __webpack_public_path__ + "static/media/IconAttachment.1367c8aa657e2a8cd30a6f0d0e3d8089.svg";
export { ForwardRef as ReactComponent };